// removed by extract-text-webpack-plugin
module.exports = {"footer":"_3Pcd0vEGfKwjQKblDJXEb_","build-time":"W5Iti-1GHSlyGMT6Up1Jp","credit-cost":"_2p36PydLmQFeZ5hf3QzAlr","command":"_3I5R1I6AIugE5OGbO2ooYN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/item/components/footer/footer.css
// module id = 36
// module chunks = 0